module.exports = __webpack_public_path__ + "img/iralex-logo.74718d06.svg";